import React, { useEffect, useState } from "react";
import { listMetrics, getAllMetrics } from "../../../services/MetricService";
import { Center, Spinner } from "@chakra-ui/react";
import showToast from "../../../hooks/useCustomToast";
import { Header, MetricProto } from "build-ts/metadata";
import KnowledgeGraphVisualizer from "../../../components/configuration/mkg/KnowledgeGraphVisualizer";
import { useConfigurationContext } from "context/ConfigurationContext";

interface ViewMKGContainerProps {
  shouldReload?: boolean; // When this is true, it triggers a reload
}

const ViewMKGContainer: React.FC<ViewMKGContainerProps> = ({ shouldReload }) => {
  const { setMetricList } = useConfigurationContext();
  const [metricInfoMap, setMetricInfoMap] = useState<Map<string, MetricProto>>(
    new Map()
  );
  const [loading, setLoading] = useState<boolean>(true);
  const fetchData = async () => {
    setLoading(true);
    try {
      const headers = await listMetrics("" /* modelId */);
      setMetricList(headers);

      if (headers?.length) {
        const metricIds = headers.map((h: Header) => h.id!);
        const metricInfoArray = await getAllMetrics(metricIds, true);
        const dataMap = new Map<string, MetricProto>();
        metricInfoArray.forEach((m) => {
          if (m.header?.id) dataMap.set(m.header.id, m);
        });
        setMetricInfoMap(dataMap);
      }
    } catch (error) {
      showToast("Error fetching data", "", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (shouldReload) {
      setMetricInfoMap(new Map());
      fetchData();
    }
  }, [shouldReload]);

  return (
    <>
      {loading ? (
        // Render a loader while loading is true
        <Center h="100vh">
          <Spinner size="xl" color="#purple.700" />
        </Center>
      ) : (
        <KnowledgeGraphVisualizer
          metricInfoMap={metricInfoMap}
        />
      )}
    </>
  );
};

export default ViewMKGContainer;
